import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src/lib/+state';
import { NavController } from '@ionic/angular';
import { CHOOSE_MENU_TABS } from '@symphony-solo/shared/utils/src/lib';
import { AuthenticationFacade } from '../+state/authentication.facade';
import { catchError, first, map } from 'rxjs/operators';
import { CartFacade } from '@symphony-solo/domain/cart/src/lib/+state/cart.facade';

@Injectable()
export class ScanQRUserGuard implements CanActivate {
  constructor(
    private companyConfigFacade: CompanyConfigFacade,
    private navCtrl: NavController,
    private authenticationFacade: AuthenticationFacade,
    private cartFacade: CartFacade
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([
      this.companyConfigFacade.isAnonymousBrowsing$,
      this.authenticationFacade.isAuthenticated$,
      this.authenticationFacade.isAccountValidated$,
      this.companyConfigFacade.isOrderFromSite$,
      this.cartFacade.cart$,
    ]).pipe(
      first(),
      map(([isAnonymous, isAuthenticated, isAccountValidated, isOrderFromSite, cart]) => {
        this.clearCache(isAuthenticated, isOrderFromSite, cart);
        if (isAnonymous) {
          if (isOrderFromSite) {
            if (state.url.includes('choose-location') && isAccountValidated) {
              this.navCtrl.navigateRoot(CHOOSE_MENU_TABS);
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      }),
      catchError((err) => {
        this.navCtrl.navigateRoot(['/login']);
        return of(true);
      })
    );
  }

  private async clearCache(isAuthenticated, isOrderFromSite, cart) {
    if (!cart?.length && isAuthenticated && isOrderFromSite) {
      this.companyConfigFacade.clearQRScanData();
    }
  }
}
